import { combineReducers } from 'redux';

import auth from '../modules/auth';
import campaign from '../modules/campaign/campaign.reducer';
import content from '../modules/content/content.reducer';
import channel from '../modules/channel/channel.reducer';
import prize from '../modules/prize/prize.reducer';
import product from '../modules/product/product.reducer';
import productCategory from '../modules/product-category/product-category.reducer';
import productDescription from '../modules/product-description/product-description.reducer';
import region from '../modules/region/region.reducer';
import team from '../modules/team/team.reducer';
import transaction from '../modules/transaction/transaction.reducer';
import user from '../modules/user/user.reducer';

const entities = combineReducers({
  campaign,
  content,
  channel,
  prize,
  product,
  productCategory,
  productDescription,
  region,
  team,
  transaction,
  user,
});

const rootReducer = combineReducers({
  entities,
  [auth.constants.NAME] : auth.reducer,
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js